import React from 'react';
import { Button } from './ui/Button';
import { CheckIcon, AlertCircleIcon } from 'lucide-react';
export function Pricing() {
  const freePlanFeatures = ['24/7 crisis support', 'Basic MimiBot conversations', 'Community support in public Tribes', 'Limited Growth Path access', 'Journal with basic features'];
  const proPlanFeatures = ['Everything in Free', 'Unlimited MimiBot conversations', 'Access to all Tribes and private groups', 'Full access to all Growth Paths', 'Advanced journal with pattern recognition', '1 free therapy session per month', 'Discounted rates for additional sessions'];
  return <section id="pricing" className="py-16" data-id="element-138">
      <div className="container mx-auto px-4" data-id="element-139">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-141">
            Mental wellness that works for your budget
          </h2>
          <p className="text-lg text-gray-700" data-id="element-142">
            MimiApp offers flexible pricing options to ensure mental wellness is
            accessible to all young Africans, regardless of economic situation.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-143">
          {/* Free Plan */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8" data-id="element-144">
            <div className="mb-6" data-id="element-145">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-146">
                Free Plan
              </h3>
              <p className="text-gray-700" data-id="element-147">Essential support for everyone</p>
            </div>
            <div className="mb-6" data-id="element-148">
              <div className="text-4xl font-bold text-gray-900 mb-1" data-id="element-149">0 KES</div>
              <p className="text-gray-600" data-id="element-150">Forever free</p>
            </div>
            <div className="mb-8" data-id="element-151">
              <ul className="space-y-3" data-id="element-152">
                {freePlanFeatures.map((feature, index) => <li key={index} className="flex items-start" data-id="element-153">
                    <CheckIcon className="h-5 w-5 text-emerald-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-154" />
                    <span className="text-gray-700" data-id="element-155">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <Button variant="outline" fullWidth data-id="element-156">
              Get Started Free
            </Button>
          </div>
          {/* Pro Plan */}
          <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl shadow-md p-8 text-white relative overflow-hidden" data-id="element-157">
            <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-3 py-1 uppercase tracking-wider" data-id="element-158">
              Most Popular
            </div>
            <div className="mb-6" data-id="element-159">
              <h3 className="text-xl font-bold mb-2" data-id="element-160">Pro Plan</h3>
              <p className="text-white/90" data-id="element-161">Complete mental wellness journey</p>
            </div>
            <div className="mb-6" data-id="element-162">
              <div className="text-4xl font-bold mb-1" data-id="element-163">
                Starting at 300 KES
                <span className="text-lg font-normal" data-id="element-164">/month</span>
              </div>
              <p className="text-white/90" data-id="element-165">
                Sliding scale based on your situation
              </p>
            </div>
            <div className="mb-8" data-id="element-166">
              <ul className="space-y-3" data-id="element-167">
                {proPlanFeatures.map((feature, index) => <li key={index} className="flex items-start" data-id="element-168">
                    <CheckIcon className="h-5 w-5 text-white mt-0.5 mr-3 flex-shrink-0" data-id="element-169" />
                    <span data-id="element-170">{feature}</span>
                  </li>)}
              </ul>
            </div>
            <Button variant="secondary" fullWidth data-id="element-171">
              Upgrade to Pro
            </Button>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mt-8 bg-amber-50 rounded-lg p-6 border border-amber-100 flex items-start" data-id="element-172">
          <AlertCircleIcon className="h-6 w-6 text-amber-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-173" />
          <div data-id="element-174">
            <h4 className="font-medium text-gray-900 mb-1" data-id="element-175">
              Crisis support is always free
            </h4>
            <p className="text-gray-700" data-id="element-176">
              We believe everyone deserves support in moments of crisis. Our
              emergency support features are available to all users, regardless
              of plan.
            </p>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mt-8 text-center" data-id="element-177">
          <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-178">
            Flexible payment options
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-179">
            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-180">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/M-PESA_LOGO-01.svg/1200px-M-PESA_LOGO-01.svg.png" alt="M-Pesa" className="h-8" data-id="element-181" />
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-182">
              <img src="https://www.mastercard.us/content/dam/public/mastercardcom/na/us/en/homepage/Home/mc-logo-52.svg" alt="Mastercard" className="h-8" data-id="element-183" />
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-184">
              <img src="https://www.visa.co.ke/dam/VCOM/regional/cemea/kenya/home-page/hero-banner/visa-logo-800x450.jpg" alt="Visa" className="h-8" data-id="element-185" />
            </div>
            <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-186">
              <img src="https://www.paypal.com/c2/digitalassets/c/website/marketing/apac/C2/logos/logo-paypal-color.svg" alt="PayPal" className="h-8" data-id="element-187" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}